import FormItem from "@components/formItem";
import { BANK_LIST } from "@enums";
import CloseIcon from "@pages/casino/assets/icons/CloseIcon.jsx";
import {
	ItemWrapper,
	ModalItem,
	ModalItemsWrapper,
} from "@pages/casino/components/Dropdown/element";
import { ModalHeader } from "@pages/casino/components/Modal/elements.js";
import Modal from "@pages/casino/components/Modal/index.jsx";
import { CloseIconOverlay } from "@pages/casino/containers/SearchModal/elements";
import { StakeFieldWrapper } from "@pages/profile-v2/pages/deposit/baseItems";
import FloatingLabelButton from "@pages/profile-v2/pages/withdraw/FloatingLabelButton";
import { BoxWrapper } from "@pages/profile/withdraw/baseItems";
import React from "react";
import MaskInput from "react-maskinput";
import { Box, Content, ContentTitle, MaskedInput, MaskedInputLabel } from "../baseItems";
import Base from "./base";

export default class BankTransfer extends Base {
	constructor(props) {
		super(props);
		this.state = {
			...this.state,
			open: false,
			selectedItem: null,
			bankName: "",
			showBranchCodeMask: false,
			showAccountMask: false,
			showFullNameMask: false,
			showSSNMask: false,
			showSenderSSNMask: false,
			showIdExpirationDateMask: false,
			showPhoneNumberMask: false,
			showIbanMask: false,
			canForward: false,
			branchCodeValue: "",
			accountValue: "",
			fullNameValue: "",
			ssnValue: "",
			senderSSNValue: "",
			idExpirationDateValue: "",
			phoneNumberValue: "",
			branchCode: "",
			account: "",
			fullName: "",
			ssn: "",
			senderSSN: "",
			idExpirationDate: "",
			phoneNumber: "",
			iban: "",
			ibanValue: "",
		};
		this.branchCodeRef = React.createRef();
		this.accountRef = React.createRef();
		this.fullNameRef = React.createRef();
		this.ssnRef = React.createRef();
		this.senderSSNRef = React.createRef();
		this.idExpirationDateRef = React.createRef();
		this.phoneNumberRef = React.createRef();
		this.ibanRef = React.createRef();
	}

	componentDidMount() {
		this.checkRequiredFields();
		super.componentDidMount();
	}

	componentDidUpdate(prevProps, prevState) {
		if (
			prevState.stake !== this.state.stake ||
			prevState.account !== this.state.account ||
			prevState.selectedCurrency !== this.state.selectedCurrency ||
			prevState.ssn !== this.state.ssn ||
			prevState.fullName !== this.state.fullName ||
			prevState.bankName !== this.state.bankName ||
			prevState.branchCode !== this.state.branchCode ||
			prevState.iban !== this.state.iban ||
			prevState.phoneNumber !== this.state.phoneNumber ||
			prevState.senderSSN !== this.state.senderSSN ||
			prevState.idExpirationDate !== this.state.idExpirationDate
		) {
			this.checkRequiredFields();
		}
	}

	handleFocus = (field) => {
		this.setState({ [field]: true });
	};

	handleBlur = (field, e) => {
		const value = e.target.value.replace(/_/g, "").trim();
		let cleanedValue = value;
		if (field === "showPhoneNumberMask") {
			cleanedValue = value.replace(/^\+90\s*\(?\)?\s*/g, "").trim();
		} else if (field === "showIbanMask") {
			cleanedValue = value.replace(/^TR/g, "").trim();
		} else if (field === "showIdExpirationDateMask") {
			cleanedValue = value.replace(/\//g, "").trim();
		}
		const isEmptyOrMasked = cleanedValue === "";
		this.setState(
			(prevState) => ({
				[field]: false,
				[`${field.replace("show", "").toLowerCase()}Value`]: isEmptyOrMasked
					? ""
					: cleanedValue,
				[field.replace("show", "").toLowerCase()]: isEmptyOrMasked
					? ""
					: field === "showPhoneNumberMask"
						? `+90${cleanedValue}`
						: field === "showIbanMask"
							? `TR${cleanedValue}`
							: cleanedValue,
			}),
			this.checkRequiredFields
		);
	};

	checkRequiredFields = () => {
		const {
			stake,
			account,
			selectedCurrency,
			ssn,
			fullName,
			bankName,
			branchCode,
			iban,
			phoneNumber,
			senderSSN,
			idExpirationDate,
		} = this.state;
		if (
			stake &&
			account &&
			selectedCurrency &&
			ssn &&
			fullName &&
			bankName &&
			branchCode &&
			iban &&
			phoneNumber &&
			senderSSN &&
			idExpirationDate
		) {
			this.setState({ canForward: true });
		} else {
			this.setState({ canForward: false });
		}
	};

	onEnterValue = (field, e) => {
		const value = e.target.value.replace(/_/g, "").trim();
		let cleanedValue = value;
		if (field === "phoneNumber") {
			cleanedValue = value.replace(/^\+90\s*\(?\)?\s*/g, "").trim();
		} else if (field === "iban") {
			cleanedValue = value.replace(/^TR/g, "").trim();
		} else if (field === "idExpirationDate") {
			cleanedValue = value.replace(/\//g, "").trim();
		}
		this.setState(
			{
				[field]:
					field === "phoneNumber"
						? `+90${cleanedValue}`
						: field === "iban"
							? `TR${cleanedValue}`
							: cleanedValue,
				[`${field}Value`]: cleanedValue,
			},
			this.checkRequiredFields
		);
	};

	handleSelect = (item) => {
		this.setState({ bankName: item.label, open: false, selectedItem: item });
	};

	preventFocus = (e) => {
		e.preventDefault();
		this.setState({ open: true });
	};

	getStep1(translate) {
		const {
			bankName,
			open,
			selectedItem,
			showBranchCodeMask,
			branchCodeValue,
			branchCode,
			showAccountMask,
			accountValue,
			account,
			showFullNameMask,
			fullNameValue,
			fullName,
			showSSNMask,
			ssnValue,
			ssn,
			showSenderSSNMask,
			senderSSNValue,
			senderSSN,
			showIdExpirationDateMask,
			idExpirationDateValue,
			idExpirationDate,
			showPhoneNumberMask,
			phoneNumberValue,
			phoneNumber,
			showIbanMask,
			ibanValue,
			iban,
		} = this.state;
		let bankOptions = [
			{ value: 0, label: translate("PLEASE_SELECT") },
			{ value: "papara", label: translate("PAPARA") },
		];
		BANK_LIST.forEach((item) => {
			let newOpt = { value: item.id, label: item.bankName };
			bankOptions.push(newOpt);
		});
		let selectedBank = bankName ? bankOptions.find((o) => o.value === bankName)?.value : 0;
		const filteredItems = bankOptions.filter((item) => item.value !== 0);

		return (
			<Content>
				<ContentTitle>{translate("Payment_Stake")}</ContentTitle>
				<BoxWrapper>
					{this.getCurrencyField(translate)}
					<StakeFieldWrapper>
						<div className="stake-field">
							{this.getStakeField(translate("AMOUNT"), false)}
						</div>
						<div className="min-max-field">{this.renderMinMax()}</div>
					</StakeFieldWrapper>
				</BoxWrapper>
				<BoxWrapper>
					<FormItem onRegister={() => this.registerField({ name: "bankName" })}>
						<Box>
							<FloatingLabelButton
								label={translate("BANK_NAME")}
								name="bankName"
								type="text"
								onClick={this.preventFocus}
								value={bankName}
								onChange={(e) => this.setState({ bankName: e.target.value })}
							/>
						</Box>
					</FormItem>
					<FormItem onRegister={() => this.registerField({ name: "branchCode" })}>
						<Box>
							<MaskedInput>
								<MaskInput
									ref={this.branchCodeRef}
									alwaysShowMask={window.IS_MARS ? true : false}
									onFocus={() => this.handleFocus("showBranchCodeMask")}
									onBlur={(e) => this.handleBlur("showBranchCodeMask", e)}
									value={showBranchCodeMask ? branchCode : branchCodeValue}
									mask="00000000000000000000"
									maskChar={showBranchCodeMask ? "_" : ""}
									size={20}
									onChange={(e) => this.onEnterValue("branchCode", e)}
								/>
								<MaskedInputLabel
									isFocused={showBranchCodeMask}
									hasValue={branchCodeValue}>
									{translate("BRANCH_CODE")}
								</MaskedInputLabel>
							</MaskedInput>
						</Box>
					</FormItem>
				</BoxWrapper>
				<BoxWrapper>
					<FormItem onRegister={() => this.registerField({ name: "account" })}>
						<Box>
							<MaskedInput>
								<MaskInput
									ref={this.accountRef}
									alwaysShowMask={window.IS_MARS ? true : false}
									onFocus={() => this.handleFocus("showAccountMask")}
									onBlur={(e) => this.handleBlur("showAccountMask", e)}
									value={showAccountMask ? account : accountValue}
									mask="00000000000000000000"
									maskChar={showAccountMask ? "_" : ""}
									size={20}
									onChange={(e) => this.onEnterValue("account", e)}
								/>
								<MaskedInputLabel
									isFocused={showAccountMask}
									hasValue={accountValue}>
									{translate("BANK_ACCOUNT_NO")}
								</MaskedInputLabel>
							</MaskedInput>
						</Box>
					</FormItem>
					<FormItem onRegister={() => this.registerField({ name: "fullName" })}>
						<Box>
							<MaskedInput>
								<input
									ref={this.fullNameRef}
									onFocus={() => this.handleFocus("showFullNameMask")}
									onBlur={(e) => this.handleBlur("showFullNameMask", e)}
									value={fullName}
									size={30}
									onChange={(e) => this.onEnterValue("fullName", e)}
								/>
								<MaskedInputLabel
									isFocused={showFullNameMask}
									hasValue={fullNameValue}>
									{translate("SENDER_FULLNAME")}
								</MaskedInputLabel>
							</MaskedInput>
						</Box>
					</FormItem>
				</BoxWrapper>
				<BoxWrapper>
					<FormItem onRegister={() => this.registerField({ name: "ssn" })}>
						<Box>
							<MaskedInput>
								<MaskInput
									ref={this.ssnRef}
									alwaysShowMask={window.IS_MARS ? true : false}
									onFocus={() => this.handleFocus("showSSNMask")}
									onBlur={(e) => this.handleBlur("showSSNMask", e)}
									value={showSSNMask ? ssn : ssnValue}
									mask="0 0 0 0 0 0 0 0 0 0 0"
									maskChar={showSSNMask ? "_" : ""}
									size={20}
									onChange={(e) => this.onEnterValue("ssn", e)}
								/>
								<MaskedInputLabel
									isFocused={showSSNMask}
									hasValue={ssnValue}>
									{translate("NATIONAL_ID_NO")}
								</MaskedInputLabel>
							</MaskedInput>
						</Box>
					</FormItem>
					<FormItem onRegister={() => this.registerField({ name: "senderSSN" })}>
						<Box>
							<MaskedInput>
								<MaskInput
									ref={this.senderSSNRef}
									alwaysShowMask={window.IS_MARS ? true : false}
									onFocus={() => this.handleFocus("showSenderSSNMask")}
									onBlur={(e) => this.handleBlur("showSenderSSNMask", e)}
									value={showSenderSSNMask ? senderSSN : senderSSNValue}
									mask="0 0 0 0 0 0 0 0 0 0 0"
									maskChar={showSenderSSNMask ? "_" : ""}
									size={20}
									onChange={(e) => this.onEnterValue("senderSSN", e)}
								/>
								<MaskedInputLabel
									isFocused={showSenderSSNMask}
									hasValue={senderSSNValue}>
									{translate("SENDER_SSN")}
								</MaskedInputLabel>
							</MaskedInput>
						</Box>
					</FormItem>
				</BoxWrapper>
				<BoxWrapper>
					<FormItem onRegister={() => this.registerField({ name: "idExpirationDate" })}>
						<Box>
							<MaskedInput>
								<MaskInput
									ref={this.idExpirationDateRef}
									alwaysShowMask={window.IS_MARS ? true : false}
									onFocus={() => this.handleFocus("showIdExpirationDateMask")}
									onBlur={(e) => this.handleBlur("showIdExpirationDateMask", e)}
									value={
										showIdExpirationDateMask
											? idExpirationDate
											: idExpirationDateValue
									}
									mask="00/00/0000"
									maskChar={showIdExpirationDateMask ? "_" : ""}
									size={10}
									onChange={(e) => this.onEnterValue("idExpirationDate", e)}
								/>
								<MaskedInputLabel
									isFocused={showIdExpirationDateMask}
									hasValue={idExpirationDateValue}>
									{translate("ID_EXPIRATION_DATE")}
								</MaskedInputLabel>
							</MaskedInput>
						</Box>
					</FormItem>
					<FormItem onRegister={() => this.registerField({ name: "phoneNumber" })}>
						<Box>
							<MaskedInput>
								<MaskInput
									ref={this.phoneNumberRef}
									alwaysShowMask={window.IS_MARS ? true : false}
									onFocus={() => this.handleFocus("showPhoneNumberMask")}
									onBlur={(e) => this.handleBlur("showPhoneNumberMask", e)}
									value={showPhoneNumberMask ? phoneNumber : phoneNumberValue}
									mask="+9\0 (000) 000 00 00"
									maskChar={showPhoneNumberMask ? "_" : ""}
									size={20}
									onChange={(e) => this.onEnterValue("phoneNumber", e)}
								/>
								<MaskedInputLabel
									isFocused={showPhoneNumberMask}
									hasValue={phoneNumberValue}>
									{translate("PHONE_NUMBER")}
								</MaskedInputLabel>
							</MaskedInput>
						</Box>
					</FormItem>
				</BoxWrapper>
				<BoxWrapper>
					<FormItem onRegister={() => this.registerField({ name: "iban" })}>
						<Box>
							<MaskedInput>
								<MaskInput
									ref={this.ibanRef}
									alwaysShowMask={window.IS_MARS ? true : false}
									onFocus={() => this.handleFocus("showIbanMask")}
									onBlur={(e) => this.handleBlur("showIbanMask", e)}
									value={showIbanMask ? iban : ibanValue}
									mask="TR00 0000 0000 0000 0000 0000 00"
									maskChar={showIbanMask ? "_" : ""}
									size={30}
									onChange={(e) => this.onEnterValue("iban", e)}
								/>
								<MaskedInputLabel
									isFocused={showIbanMask}
									hasValue={ibanValue}>
									{translate("IBAN")}
								</MaskedInputLabel>
							</MaskedInput>
						</Box>
					</FormItem>
				</BoxWrapper>

				{/* Modal */}
				<Modal
					position={"top"}
					hasOverflow
					open={open}
					isPaymentPage
					onClose={() => this.setState({ open: false })}>
					<ModalItemsWrapper>
						<ModalHeader>{translate("Bank_Selection")}</ModalHeader>
						<ItemWrapper
							isPaymentPage
							className="item-wrapper">
							{filteredItems.map((item) => (
								<ModalItem
									key={item.value}
									isSelected={item.value === selectedItem?.value}
									onClick={() => this.handleSelect(item)}>
									{item.label}
								</ModalItem>
							))}
							<CloseIconOverlay />
							<CloseIcon
								className="modal-close-icon payment"
								onClick={() => {
									this.setState({ open: false });
								}}
							/>
						</ItemWrapper>
					</ModalItemsWrapper>
				</Modal>
			</Content>
		);
	}

	goForward(step) {
		const { stake, selectedCurrency } = this.state;
		const { selectedWithdraw } = this.props;

		if (!this.state.canForward) return;

		const currency = selectedWithdraw.currencies.find(
			(item) => item.currency === selectedCurrency
		);

		if (currency && stake < currency.withdraw.min) {
			this.props.showAlert({
				type: "error",
				msg: "STAKE_RANGE_WARNING_MIN",
				title: "ERROR",
			});
			return;
		}

		if (currency && stake > currency.withdraw.max) {
			this.props.showAlert({
				type: "error",
				msg: "STAKE_RANGE_WARNING_MAX",
				title: "ERROR",
			});
			return;
		}

		const newStep = step + 1;
		this.setState({ currentStep: newStep });
	}

	makeExternalPayment() {
		const {
			stake,
			account,
			selectedCurrency,
			ssn,
			fullName,
			bankName,
			branchCode,
			iban,
			phoneNumber,
			senderSSN,
			idExpirationDate,
		} = this.state;
		let withdrawData = {
			type: "BankTransfer",
			amount: {
				value: Number(stake),
				currency: selectedCurrency ? selectedCurrency : "TRY",
			},
			accountNumber: account,
			ssn: ssn.replaceAll(" ", ""),
			iban: iban.replaceAll(" ", ""),
			fullName: fullName,
			bankName: bankName,
			branchCode: branchCode,
			language: this.getActiveLanguageCode(),
			phoneNumber: phoneNumber.replaceAll(" ", ""),
			idExpirationDate: idExpirationDate.replaceAll("/", "."),
			senderSsn: senderSSN.replaceAll(" ", ""),
		};
		this.props.onWithdraw(withdrawData, () => {
			this.onBackToWithdrawPage();
		});
	}

	render() {
		const { canForward } = this.state;
		return super.render();
	}
}
